import { render, staticRenderFns } from "./relationEvnModel.vue?vue&type=template&id=498d0f1a&scoped=true"
import script from "./relationEvnModel.vue?vue&type=script&lang=js"
export * from "./relationEvnModel.vue?vue&type=script&lang=js"
import style0 from "./relationEvnModel.vue?vue&type=style&index=0&id=498d0f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d0f1a",
  null
  
)

export default component.exports